import Backbone from 'backbone'
// import _ from 'underscore'
import Logger from 'Logger'

import { ItemsCollection } from './items.collection'

import tpl from './items.mustache'
import detailLink from '../template/part.detailLink.mustache'

import { detailHandler, openPayPopup } from '../../manager/view.handler'

export var ItemsView = Backbone.View.extend({
  tagName: 'div',
  className: 'ItemsView',
  collection: new ItemsCollection(),
  template: tpl,
  events: {
    'click [data-id]': openPayPopup,
    'click [data-detail-pop]': detailHandler,
  },
  initialize: function () {
    this.collection.once('sync', this.render, this)
    this.collection.fetch()
  },
  render: function () {
    var itemsBody = this.template.render(
      {
        items: this.collection.toJSON(),
      },
      { detailLink: detailLink }
    )
    this.$el.empty().append(itemsBody)
    return this
  },
})
